import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SelectInputComponent } from '../select-input/select-input.component';
import { CommonModule } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-table-dropdown',
    standalone: true,
    imports: [CommonModule, SelectInputComponent, FormsModule],
    templateUrl: './table-dropdown.component.html',
    styleUrl: './table-dropdown.component.css',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SelectInputComponent
        }
    ],
})
export class TableDropdownComponent implements ICellRendererAngularComp {
    params: any;
    value: any;
    options: any[] = [];
    placeholder: string = 'Select';
    disabled: boolean = false;
    clearable: boolean = true;
    show_email: boolean = false;

    agInit(params: any): void {
        this.params = params;
        this.value = params.value;
        this.options = params.options || [];
        this.placeholder = params.placeholder || 'Select';
        this.show_email = params.show_email || false;
        // Check if disabled is a function or boolean
        if (typeof params.disabled === 'function') {
            this.disabled = params.disabled(params.data);
        } else {
            this.disabled = params.disabled || false;
        }
        // Same pattern for clearable — a function is evaluated per-row against params.data.
        if (typeof params.clearable === 'function') {
            this.clearable = params.clearable(params.data);
        } else {
            this.clearable = params.clearable !== undefined ? params.clearable : true;
        }
    }

    refresh(params: any): boolean {
        this.agInit(params);
        return true;
    }

    onValueChange(event: any) {
        // If specific return key is configured, extract it, otherwise use full value
        // Assuming SelectInputComponent emits { value: ... } object or similar based on its implementation
        // event from SelectInputComponent is { value: ..., depended: ... }

        // We typically want to update the grid data with the simple value (id/code) not the whole object if that's how it's stored
        // But 'event.value' in SelectInputComponent seems to be the selected object(s) or value depending on is_multiple?

        // Let's check SelectInputComponent again.
        // this.valueChange.emit({ value: this.selectedValues, depended: this.depended });
        // this.selectedValues is the option OBJECT(s) found in options.

        // So event.value is the selected object.

        const newValue = event.value ? event.value.value : null; // Assuming option has .value

        // Call custom onChange if provided
        if (this.params.onChange) {
            this.params.onChange(newValue, this.params.data, this.params);
        }
    }
}
